/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Paper,
  Typography,
  Divider,
} from "@material-ui/core";
import { Add, NavigateBefore, Remove } from "@material-ui/icons";
import { Autocomplete } from "@material-ui/lab";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { Save } from "react-feather";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import PaymentIcon from "@material-ui/icons/Payment";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckIcon from "@material-ui/icons/Check";

const useStyles = makeStyles((theme) => ({
  chip: {
    "& span": {
      color: `${theme.palette.text.primary} !important`,
    },
  },
  root: {
    width: "100%",
  },
  button: {
    padding: theme.spacing(2),
    width: "100%",
    display: "flex",
    justifyContent: "end",
  },
  popupRoot: {
    position: "fixed",
    top: 0,
    left: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing(1),
    height: "100vh",
    width: "100vw",
    backgroundColor: "rgba(0, 0, 0, 0.1)",
    zIndex: 1000,
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    width: "500px",
    borderRadius: theme.spacing(2),
    boxShadow: theme.shadows[10],
  },
  header: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    alignItems: "center",
    textAlign: "center",
  },
  messageBox: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(2),
  },
  submitButtons: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: theme.spacing(2),
  },
  buttonPopup: {
    padding: theme.spacing(1, 3),
    gap: theme.spacing(1),
    display: "flex",
    alignItems: "center",
  },
}));

function Duo({ setPhase, files, setFileMeta }) {
  const [showPopup, setShowPopup] = useState(false);
  const isInputFormatValid = () => true;
  const isFileConfigUnique = () => true;
  const [formData, setFormData] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();
  const { t } = useTranslation();

  const handleSubmit = async (event) => {
    event.preventDefault();
    let data = [];
    if (
      formData.filter(
        (data) => _.isEmpty(data.pair_1) || _.isEmpty(data.pair_2)
      ).length > 0
    ) {
      enqueueSnackbar(
        t(
          "form_input_not_valid_message",
          "Form input are not valid. Please check and try again."
        ),
        {
          variant: "error",
        }
      );
      return;
    }
    formData.forEach((form) => {
      let tmpRow = {
        name: form.name,
        reports: [form.pair_1.sample_id, form.pair_2.sample_id],
      };
      data.push(tmpRow);
    });
    setFileMeta(data);

    if (isInputFormatValid()) {
      if (isFileConfigUnique()) {
        setShowPopup(true);
      } else {
        enqueueSnackbar(
          t(
            "form_conf_not_unique_message",
            "Form configuration is not unique. Please check and try again."
          ),
          {
            variant: "error",
          }
        );
      }
    } else {
      enqueueSnackbar(
        t(
          "form_input_not_valid_message",
          "Form input are not valid. Please check and try again."
        ),
        {
          variant: "error",
        }
      );
    }
  };

  const handleConfirm = () => {
    setPhase("without_credit_submit");
  };

  const handleCancel = () => {
    setShowPopup(false);
  };

  const removeRow = (index) => {
    if (formData.length <= 1) {
      enqueueSnackbar(t("At least one row must be present!"), {
        variant: "warning",
      });
      return;
    }
    if (index > -1) {
      formData.splice(index, 1);
    }
    setFormData([...formData]);
  };

  const addRow = () => {
    formData.push({});
    setFormData([...formData]);
  };

  const handleAutoCompleteChange = (index, name) => (e, value) => {
    formData[index][name] = value;
    formData.forEach((data) => {
      if (data?.pair_1) {
        data.name = data.pair_1.name
          .split("/")
          [data.pair_1.name.split("/").length - 1].replace(".tsv", "");
        data.name += "-";
      }
      if (data?.pair_2) {
        data.name += data.pair_2.name
          .split("/")
          [data.pair_2.name.split("/").length - 1].replace(".tsv", "");
      }
    });
    setFormData([...formData]);
  };

  // useEffect(() => {
  //   formData.map((data) => {
  //     if (data?.pair_1) {
  //       data.name =
  //         data.pair_1.name.split("/")[data.pair_1.name.split("/").length - 1];
  //       data.name += "-";
  //     }
  //     if (data?.pair_2) {
  //       data.name +=
  //         data.pair_2.name.split("/")[data.pair_2.name.split("/").length - 1];
  //     }
  //   });
  //   setFormData([...formData]);
  // }, [formData]);

  useEffect(() => {
    // Initialize to minimum form data
    if (files.length > 0) {
      const length = (files.length * (files.length - 1)) / 2;
      for (let i = 0; length > i; i++) {
        formData.push({});
      }
      setFormData([...formData]);
    }
  }, []);

  return (
    <>
      {showPopup && (
        <Box className={classes.popupRoot}>
          <Paper className={classes.paper} elevation={3}>
            <Box className={classes.header}>
              <Typography
                variant="h4"
                color="primary"
                style={{ fontWeight: "bold" }}
              >
                {t("Duo Analysis")}
              </Typography>
            </Box>

            <Divider />

            <Box className={classes.messageBox}>
              <PaymentIcon color="primary" />
              <Typography variant="body1">
                {t("No credit is charged for Dual Comparative Analysis")}
              </Typography>
            </Box>

            <Box className={classes.submitButtons}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleCancel}
                className={classes.buttonPopup}
                startIcon={<CancelIcon />}
              >
                {t("Cancel")}
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleConfirm}
                className={classes.buttonPopup}
                startIcon={<CheckIcon />}
              >
                {t("Submit")}
              </Button>
            </Box>
          </Paper>
        </Box>
      )}

      <Box className={classes.root}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t("Report Name")}</TableCell>
              <TableCell>{t("First Duo Report")}</TableCell>
              <TableCell>{t("Second Duo Report")}</TableCell>
              <TableCell width={20}>{t("Remove")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {formData.map((data, index) => {
              return (
                <DuoTableRow
                  index={index}
                  data={data}
                  files={files}
                  handleAutoCompleteChange={handleAutoCompleteChange}
                  t={t}
                  removeRow={removeRow}
                />
              );
            })}
          </TableBody>
        </Table>
        <Box className={classes.button}>
          <Button variant="contained" onClick={addRow} color="primary">
            <Add />
          </Button>
        </Box>
        <Box display="flex" width="100%" mt={5}>
          <Button
            variant="outlined"
            color="secondary"
            startIcon={<NavigateBefore />}
            onClick={() => setPhase("init")}
          >
            {t("Back")}
          </Button>
          <Button
            style={{ marginLeft: "auto" }}
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            startIcon={<Save />}
          >
            {t("Submit")}
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default Duo;
function DuoTableRow({
  data,
  files,
  index,
  handleAutoCompleteChange,
  t,
  removeRow,
}) {
  return (
    <TableRow>
      <TableCell>
        <TextField
          variant="outlined"
          value={data["name"] || ""}
          fullWidth
          disabled
        />
      </TableCell>
      <TableCell>
        <Autocomplete
          name="pair_1"
          options={files}
          value={data["pair_1"] || null}
          noOptionsText={t("No Options")}
          onChange={handleAutoCompleteChange(index, "pair_1")}
          getOptionLabel={(option) =>
            option &&
            option.name &&
            option.name.split("/")[option.name.split("/").length - 1]
          }
          renderInput={(props) => (
            <TextField
              {...props}
              variant="outlined"
              name="pair_1"
              label={t("First Duo Report")}
            />
          )}
        />
      </TableCell>
      <TableCell>
        <Autocomplete
          name="pair_2"
          options={files}
          value={data["pair_2"] || null}
          onChange={handleAutoCompleteChange(index, "pair_2")}
          getOptionLabel={(option) =>
            option &&
            option.name &&
            option.name.split("/")[option.name.split("/").length - 1]
          }
          noOptionsText={t("No Options")}
          renderInput={(props) => (
            <TextField
              {...props}
              variant="outlined"
              name="pair_2"
              label={t("Second Duo Report")}
            />
          )}
        />
      </TableCell>
      <TableCell>
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => removeRow(index)}
        >
          <Remove />
        </Button>
      </TableCell>
    </TableRow>
  );
}
